<script setup lang="ts">
import { faUser, faUserEdit } from '@fortawesome/pro-regular-svg-icons';
import { type PeopleResponse } from '@clients/PricetrackApi';

interface IProps {
    editEnabled?: boolean;
    pax?: PeopleResponse[];
}

const { pax = [] as PeopleResponse[], editEnabled } = defineProps<IProps>();
const emit = defineEmits<{
    editPax: [];
}>();
</script>

<template>
    <div class="auto-reserve-pax-root">
        <div class="header">
            <mr-typography weight="500"> لیست مسافران </mr-typography>
            <mr-button
                :class="{ hidden: !editEnabled }"
                size="medium"
                variant="transparent"
                :right-icon="faUserEdit"
                @click="emit('editPax')"
            >
                ویرایش مسافران
            </mr-button>
        </div>
        <div class="pax-container">
            <div v-for="passenger in pax" :key="passenger.id" class="passenger">
                <mr-icon :icon="faUser" />
                <mr-typography weight="500" color="var(--cool-gray-700)">
                    {{ passenger.persianFirstName || passenger.firstName }}
                    {{ passenger.persianLastName || passenger.lastName }}
                </mr-typography>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.auto-reserve-pax-root {
    @include shadow();
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 16px;
    background: white;
    border-radius: 12px;
    gap: 8px;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-grow: 1;
        width: 100%;

        .hidden {
            visibility: hidden;
        }
    }

    .pax-container {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-grow: 1;
        width: 100%;

        .passenger {
            display: flex;
            padding: 4px 8px;
            align-items: center;
        }
    }
}
</style>
